define('OutSystems/ClientRuntime/modules/Database/Common/EntityService',["require", "exports", "tslib", "../../../DataTypes", "../../../Exceptions", "../../../Logger", "../Metadata/MetadataTableInfo", "../Metadata/MetadataTableInitializer", "../TableInfoUtils", "./EntityModelInitializer", "./ValueConstraintValidation"], function (require, exports, tslib_1, DataTypes_1, Exceptions_1, Logger, MetadataTableInfo_1, MetadataTableInitializer_1, TableInfoUtils, EntityModelInitializer_1, ValueConstraintValidation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var EntityIdOutputTypeFactory = new DataTypes_1.BasicTypeKeyedTypeFactory("Id", "idOut");
    var EntityRecordOutputTypeFactory = new DataTypes_1.ComplexTypeKeyedTypeFactory("Record", "recordOut");
    var EntityService = (function () {
        function EntityService(serializer) {
            this._serializer = serializer;
        }
        Object.defineProperty(EntityService.prototype, "database", {
            get: function () {
                return this._database;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(EntityService.prototype, "serializer", {
            get: function () {
                return this._serializer;
            },
            enumerable: false,
            configurable: true
        });
        EntityService.prototype.setDatabase = function (database) {
            Logger.trace(this, "Registering initializer for entity meta info table.");
            this._database = database;
            this._database.registerInitializer(MetadataTableInitializer_1.default);
        };
        EntityService.prototype.getDatabase = function () {
            var _this = this;
            if (!this.databasePromise) {
                this.databasePromise = new Promise(function (resolve) {
                    _this.releaseDatabaseForUse = function () { return resolve(_this.database); };
                });
            }
            return this.databasePromise;
        };
        EntityService.prototype.registerInitializer = function (entityInfos) {
            if (entityInfos && entityInfos.length > 0) {
                Logger.trace(this, "Registering initializer for entities of module '" + entityInfos[0].moduleKey + "'.");
                var initializer = new EntityModelInitializer_1.default(entityInfos, this.serializer);
                this.database.registerInitializer(initializer);
            }
        };
        EntityService.prototype.setReady = function () {
            Logger.trace(this, "Releasing the database as ready for use.");
            if (this.databasePromise) {
                this.releaseDatabaseForUse();
            }
            else {
                this.databasePromise = Promise.resolve(this.database);
            }
        };
        EntityService.wrap = function (recordToWrap, wrappingType) {
            var recordAttr = wrappingType.getAttributes()[0];
            var result = new wrappingType();
            result[recordAttr.attrName] = recordToWrap;
            return result;
        };
        EntityService.unwrap = function (wrappingRecord) {
            var recordAttr = wrappingRecord.getAttributes()[0];
            return wrappingRecord[recordAttr.attrName];
        };
        EntityService.getWrappedType = function (wrappingType) {
            var recordAttr = wrappingType.getAttributes()[0];
            return recordAttr.complexType;
        };
        EntityService.prototype.create = function (info, wrappingRecord) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var db, record, recordId, error_1, pkAttr, result;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.getDatabase()];
                        case 1:
                            db = _a.sent();
                            record = EntityService.unwrap(wrappingRecord);
                            ValueConstraintValidation_1.validateRecordForCreateOrUpdate(info, record, "create");
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4, db.executeTransaction(function (tx) { return _this.innerCreate(tx, info, record); }, true, [
                                    MetadataTableInfo_1.default,
                                    info,
                                ])];
                        case 3:
                            recordId = _a.sent();
                            return [3, 5];
                        case 4:
                            error_1 = _a.sent();
                            throw new Exceptions_1.Exceptions.DataBaseException("", error_1.message, error_1.stack);
                        case 5:
                            if (recordId === null) {
                                return [2, null];
                            }
                            pkAttr = TableInfoUtils.getIdentifierAttribute(info, record);
                            result = new (EntityIdOutputTypeFactory.getType(pkAttr.dataType))();
                            result.idOut = recordId;
                            return [2, result];
                    }
                });
            });
        };
        EntityService.prototype.innerCreate = function (transaction, info, record) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var recordId, pkCol;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, transaction.insertRecord(info, this.serializer.serialize(record, info))];
                        case 1:
                            recordId = _a.sent();
                            pkCol = TableInfoUtils.getIdentifierColumn(info);
                            if (!pkCol) {
                                return [2, null];
                            }
                            return [2, this.serializer.deserialize(recordId, pkCol)];
                    }
                });
            });
        };
        EntityService.prototype.update = function (info, wrappingRecord) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var db, record, error_2;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.getDatabase()];
                        case 1:
                            db = _a.sent();
                            record = EntityService.unwrap(wrappingRecord);
                            ValueConstraintValidation_1.validateRecordForCreateOrUpdate(info, record, "update");
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4, db.executeTransaction(function (tx) { return _this.innerUpdate(tx, info, record); }, true, [
                                    MetadataTableInfo_1.default,
                                    info,
                                ])];
                        case 3:
                            _a.sent();
                            return [3, 5];
                        case 4:
                            error_2 = _a.sent();
                            throw new Exceptions_1.Exceptions.DataBaseException("", error_2.message, error_2.stack);
                        case 5: return [2];
                    }
                });
            });
        };
        EntityService.prototype.innerUpdate = function (transaction, info, record) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    return [2, transaction.updateRecord(info, this.serializer.serialize(record, info))];
                });
            });
        };
        EntityService.prototype.createOrUpdate = function (info, wrappingRecord) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var db, record, recordId, error_3, idAttr, result;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.getDatabase()];
                        case 1:
                            db = _a.sent();
                            record = EntityService.unwrap(wrappingRecord);
                            ValueConstraintValidation_1.validateRecordForCreateOrUpdate(info, record, "create or update");
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4, db.executeTransaction(function (tx) { return _this.innerCreateOrUpdate(tx, info, record); }, true, [MetadataTableInfo_1.default, info])];
                        case 3:
                            recordId = _a.sent();
                            return [3, 5];
                        case 4:
                            error_3 = _a.sent();
                            throw new Exceptions_1.Exceptions.DataBaseException("", error_3.message, error_3.stack);
                        case 5:
                            idAttr = TableInfoUtils.getIdentifierAttribute(info, record);
                            result = new (EntityIdOutputTypeFactory.getType(idAttr.dataType))();
                            result.idOut = recordId;
                            return [2, result];
                    }
                });
            });
        };
        EntityService.prototype.innerCreateOrUpdate = function (transaction, info, record) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var recordId, pkCol;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, transaction.upsertRecord(info, this.serializer.serialize(record, info))];
                        case 1:
                            recordId = _a.sent();
                            pkCol = TableInfoUtils.getIdentifierColumn(info);
                            if (!pkCol) {
                                return [2, null];
                            }
                            return [2, this.serializer.deserialize(recordId, pkCol)];
                    }
                });
            });
        };
        EntityService.prototype.createOrUpdateAll = function (info, list) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var db, records, i, wrappingRecord, record, error_4;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.getDatabase()];
                        case 1:
                            db = _a.sent();
                            records = [];
                            for (i = 0; i < list.length; i++) {
                                wrappingRecord = list.getItem(i);
                                record = EntityService.unwrap(wrappingRecord);
                                ValueConstraintValidation_1.validateRecordForCreateOrUpdate(info, record, "create or update");
                                records.push(record);
                            }
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4, db.executeTransaction(function (tx) { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
                                    return [2, this.innerCreateOrUpdateAll(tx, info, records)];
                                }); }); }, true, [
                                    MetadataTableInfo_1.default,
                                    info,
                                ])];
                        case 3:
                            _a.sent();
                            return [3, 5];
                        case 4:
                            error_4 = _a.sent();
                            throw new Exceptions_1.Exceptions.DataBaseException("", error_4.message, error_4.stack);
                        case 5: return [2];
                    }
                });
            });
        };
        EntityService.prototype.innerCreateOrUpdateAll = function (transaction, info, records) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    return [2, transaction.upsertAllRecords(info, records.map(function (record) { return _this.serializer.serialize(record, info); }))];
                });
            });
        };
        EntityService.prototype.get = function (info, id) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var db, record, error_5, result;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.getDatabase()];
                        case 1:
                            db = _a.sent();
                            record = null;
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4, db.executeReadTransaction(function (tx) { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
                                    return [2, this.innerGet(tx, info, id)];
                                }); }); }, true, [
                                    info,
                                ])];
                        case 3:
                            record = _a.sent();
                            return [3, 5];
                        case 4:
                            error_5 = _a.sent();
                            throw new Exceptions_1.Exceptions.DataBaseException("", error_5.message, error_5.stack);
                        case 5:
                            if (!record) {
                                throw new Exceptions_1.Exceptions.DataBaseException("", info.tableName + " with id " + id + " was not found");
                            }
                            else {
                                result = new (EntityRecordOutputTypeFactory.getType(info.implicitAnonymousType))();
                                result.recordOut = EntityService.wrap(record, info.implicitAnonymousType);
                                return [2, result];
                            }
                            return [2];
                    }
                });
            });
        };
        EntityService.prototype.innerGet = function (transaction, info, id) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var idCol, record;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            idCol = TableInfoUtils.getIdentifierColumn(info);
                            return [4, transaction.getRecord(info, this.serializer.serialize(id, idCol))];
                        case 1:
                            record = _a.sent();
                            if (!record) {
                                return [2, null];
                            }
                            else {
                                return [2, this.serializer.deserialize(record, info, EntityService.getWrappedType(info.implicitAnonymousType))];
                            }
                            return [2];
                    }
                });
            });
        };
        EntityService.prototype.delete = function (info, id) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var db, error_6;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.getDatabase()];
                        case 1:
                            db = _a.sent();
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4, db.executeTransaction(function (tx) { return _this.innerDelete(tx, info, id); }, true, [
                                    MetadataTableInfo_1.default,
                                    info,
                                ])];
                        case 3:
                            _a.sent();
                            return [3, 5];
                        case 4:
                            error_6 = _a.sent();
                            throw new Exceptions_1.Exceptions.DataBaseException("", error_6.message, error_6.stack);
                        case 5: return [2];
                    }
                });
            });
        };
        EntityService.prototype.innerDelete = function (transaction, info, id) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var idCol;
                return tslib_1.__generator(this, function (_a) {
                    idCol = TableInfoUtils.getIdentifierColumn(info);
                    return [2, transaction.removeRecord(info, this.serializer.serialize(id, idCol))];
                });
            });
        };
        EntityService.prototype.deleteAll = function (info) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var db, error_7;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.getDatabase()];
                        case 1:
                            db = _a.sent();
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4, db.executeTransaction(function (tx) { return _this.innerDeleteAll(tx, info); }, true, [
                                    MetadataTableInfo_1.default,
                                    info,
                                ])];
                        case 3:
                            _a.sent();
                            return [3, 5];
                        case 4:
                            error_7 = _a.sent();
                            throw new Exceptions_1.Exceptions.DataBaseException("", error_7.message, error_7.stack);
                        case 5: return [2];
                    }
                });
            });
        };
        EntityService.prototype.innerDeleteAll = function (transaction, info) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    return [2, transaction.removeAllRecords(info)];
                });
            });
        };
        return EntityService;
    }());
    exports.default = EntityService;
});
//# sourceMappingURL=EntityService.js.map;
